
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"fill":"#D0EFEC","d":"M38.83 14.782c3.927 0 7.11 3.342 7.11 7.465a7.8 7.8 0 0 1-.323 2.23c-.117.393-.491.641-.9.641H1.48a.94.94 0 0 1-.898-.612l-.032-.092A10.2 10.2 0 0 1 0 21.099c0-5.392 4.163-9.763 9.297-9.763a.3.3 0 0 0 .264-.156c2.535-4.707 7.345-7.883 12.862-7.883 6.94 0 12.763 5.028 14.343 11.804a6.8 6.8 0 0 1 2.064-.32"}}),_c('path',{staticClass:"i-cloud",attrs:{"stroke":"#234652","d":"M10.822 22.821H2.54a.94.94 0 0 1-.898-.612 10.2 10.2 0 0 1-.582-3.407c0-5.392 4.163-9.763 9.298-9.763a.3.3 0 0 0 .263-.157C13.156 4.176 17.966 1 23.483 1c6.94 0 12.763 5.028 14.343 11.804a6.8 6.8 0 0 1 2.064-.32c3.927 0 7.11 3.343 7.11 7.466 0 .777-.113 1.526-.323 2.23-.117.393-.49.641-.9.641h-9.114"}}),_c('path',{staticClass:"i-arrows",attrs:{"stroke":"#234652","d":"m32.941 22.147-3.97 3.97L25 22.148m-1.983-4.706-3.971 3.97-3.97-3.97M29 25.64l-.05-12m-9.95 7v-11"}}),_c('path',{staticClass:"i-folder",attrs:{"stroke":"#234652","stroke-linecap":"round","stroke-linejoin":"round","d":"M34.5 43.945c0 .54-.216 1.059-.6 1.441a2.06 2.06 0 0 1-1.45.597h-16.4a2.06 2.06 0 0 1-1.45-.597c-.384-.382-.6-.9-.6-1.441V29.679c0-.54.216-1.06.6-1.441a2.06 2.06 0 0 1 1.45-.597h5.125l2.05 3.057h9.225c.544 0 1.065.215 1.45.597.384.382.6.9.6 1.44z"}})])
          )
        }
      }
    